<template>
  <div id="wrap">
    <Header/>
    <Scroll/>
    <div class="hp_productWrap">
      <div class="hp_productMain_tit"><!-- travel_title_area -->
        <h1>마이페이지</h1>
      </div>

      <div class="hp_productMain_contentWrap"> <!-- travel_content -->
        <div class="hp_productMain_contentSidebar"><!-- travel_sidebar -->
          <div class="hp_productMain_contentMenuBox">
            <ul class="hp_productMain_contentMenu"><!-- travel_menu -->
              <li @click="setMyID(1)" :class="{ 'hp_productMain_contentMenu_active': 1 === statusData.myID }">
                <a>회원정보수정</a>
              </li>
              <li @click="setMyID(2)" :class="{ 'hp_productMain_contentMenu_active': 2 === statusData.myID }">
                <a>예약결제현황</a>
              </li>
              <li @click="setMyID(3)" :class="{ 'hp_productMain_contentMenu_active': 3 === statusData.myID }">
                <a>나의관심여행</a>
              </li>
              <li @click="setMyID(4)" :class="{ 'hp_productMain_contentMenu_active': 4 === statusData.myID }">
                <a>포인트현황</a>
              </li>
              <li @click="setMyID(5)" :class="{ 'hp_productMain_contentMenu_active': 5 === statusData.myID }">
                <a>회원탈퇴</a>
              </li>
            </ul>
          </div>

          <!-- Hot Keywords -->
          <div class="hp_productMain_contentKeywordBox hp_MobNonePcBlock">
            <p class="hp_productMain_contentKeyword_tit">HOT키워드<span>여행</span></p>
            <div class="hp_productMain_contentKeyword_tagBox">
              <p v-for="item in statusData.hotKeywordData" :key="item.hot_keyword_ID">
                <a :href="`/TravelProduct?travelSearchData=${encodeURIComponent(item.hot_keyword_name)}`">
                  #{{ item.hot_keyword_name }}
                </a>
              </p>
            </div>
          </div>
        </div>

        <!-- 회원정보수정 -->
        <div class="hp_mypageListWrap" v-if="statusData.myID === 1">
          <div class="hp_mypageListWrapTit">
            회원정보수정
          </div>
          <div class="hp_reservationBox">
            <table class="hp_tableForm" cellpadding="0" cellspacing="0" summary="회원정보수정">
              <caption>회원정보수정</caption>
              <colgroup>
                <col width="30%">
                <col width="*">
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">
                    <label for = 'customer_division_name'>가입구분</label>
                  </th>
                  <td>
                    <span class="boldTxt">{{statusData.customerDivisionName}}</span>
                  </td>
                </tr>
                <tr v-if="statusData.customerDivision === 1">
                  <th scope="row">
                    <label for = 'customer_login_ID'>아이디</label>
                  </th>
                  <td>
                    <span class="boldTxt">{{formData.customerLoginID}}</span>
                  </td>
                </tr>
                <tr v-if="statusData.customerDivision === 1">
                  <th>
                    <label for = 'customer_password'>비밀번호</label>
                  </th>
                  <td>
                    <input
                      type = "password"
                      class="hp_tableInputBox"
                      id = 'customer_password'
                      v-model="formData.customerPassword"
                      maxlength="20"
                    >
                    <p class="hp_reservBox_infoTxt">* 영문, 숫자, 특수문자를 혼합하여 8~20자까지 입력.</p>
                  </td>
                </tr>
                <tr v-if="statusData.customerDivision === 1">
                  <th>
                    <label for = 'customer_password_check'>비밀번호 확인</label>
                  </th>
                  <td>
                    <input
                      type = "password"
                      class="hp_tableInputBox"
                      id = 'customer_password_check'
                      v-model="formData.customerPasswordCheck"
                      maxlength="20"
                    >
                  </td>
                </tr>
                <tr>
                  <th>
                    <label for = 'customer_name'>이름 <span class="pointTextRed">*</span></label>
                  </th>
                  <td>
                    <input
                      type = "text"
                      class="hp_tableInputBox"
                      id = 'customer_name'
                      v-model="formData.customerName"
                      maxlength="10"
                    >
                  </td>
                </tr>
                <tr>
                  <th>
                    <label for = 'customer_phone_number'>휴대폰 번호 <span class="pointTextRed">*</span></label>
                  </th>
                  <td>
                    <input
                      type = "text"
                      class="hp_tableInputBox"
                      id = 'customer_phone_number'
                      v-model="formData.customerPhoneNumber"
                      @input="formatPhoneNumber"
                      maxlength="13"
                    >
                  </td>
                </tr>
                <tr>
                  <th>
                    <label for = 'customer_email'>이메일</label>
                  </th>
                  <td>
                    <input
                      type = "text"
                      class="hp_tableInputBox"
                      id = 'customer_email'
                      v-model="formData.customerEmail"
                      maxlength="50"
                    >
                  </td>
                </tr>
                <tr>
                  <th>
                    마케팅 동의
                  </th>
                  <td>
                    <div class="hp_tableInputCheckTD">
                      <input
                        class="hp_tableInputCheck"
                        type = "checkbox"
                        id = 'customer_marketing_status'
                        v-model="formData.customerMarketingStatus"
                      >
                      <label class="hp_tableInputCheck_label" for = 'customer_marketing_status'> 마케팅 수신에 동의합니다</label>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>
                    <label for = 'security_code'>보안코드 <span class="pointTextRed">*</span></label>
                  </th>
                  <td>
                    <div class="securityTxt">{{statusData.securityCode}}</div>
                    <input
                      type = "text"
                      class="hp_tableInputBox"
                      id = 'security_code'
                      v-model="formData.securityCode"
                      maxlength="4"
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="hp_myFix_btnReservMob">
            <button @click="updateCustomer">수정하기</button>
          </div>
          <div class="hp_reservation_btnReservPc">
            <button class="hp_reservation_btnReservPc_on" @click="updateCustomer">수정하기</button>
            <button @click="goToHome">취소하기</button>
          </div>
        </div>
        <!-- 회원정보수정 -->

        <!-- 예약결제현황 -->
        <div class="hp_mypageListWrap"  v-if="statusData.myID === 2 && statusData.reservationData.length !== 0">
          <div class="hp_mypageListWrapTit hp_MobNonePcBlock">
            예약결제현황
          </div>
          <div
            class="hp_myResWrap"
            v-for="item in statusData.reservationData"
            :key="item.reservation_ID"
            v-if="statusData.reservationData.length !== 0">
            <table border="0" cellspacing="0" cellpadding="0" class="hp_myResBox" summary="예약현황">
              <caption>예약현황</caption>
              <colgroup>
                <col width="*">
              </colgroup>
              <thead>
                <tr>
                  <th scope="col">
                    <div class="hp_myRes_orderDate">
                      <div>{{item.reservation_registe}}<span class="hp_myRes_orderNum">(예약번호 : {{item.reservation_ID}})</span></div>
                      <button class="hp_myRes_ViewBtn hp_MobNonePcBlock" @click="goToReservationDetail(item.reservation_ID)">예약상세보기</button>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div class="hp_myRes_orderInfoWrap">
                      <div class="hp_myRes_orderInfoImg hp_MobNonePcBlock"><!-- 이미지 -->
                        <a :href="'/TravelProductDetail?travelProductID=' + item.travel_product_ID">
                          <img :src="item.travel_product_img1" alt="여행 메인 이미지" >
                        </a>
                      </div>
                      <div class="hp_myRes_orderInfoBox"> <!-- 내용 -->
                        <a :href="'/ReservationStatus?reservationID=' + item.reservation_ID">
                          <div class="hp_myRes_orderInfoBoxTit">
                              <p class="hp_myRes_orderPay hp_MobBlockPcNone">{{item.reservation_pay_status_name}}</p> <!-- 모바일에서만 날짜위에 결제여부 나타남 -->
                              {{ item.travel_product_name }}
                            </div>
                          <ul>
                            <li>
                              <span class="hp_myRes_orderInfoBoxIcon">예약인원</span>
                              대인 : {{item.reservation_number_count}}명, &nbsp; 소인 : {{item.reservation_number_count_child}}명
                            </li>
                            <li class="hp_myRes_orderInfoBoxBlue">
                              <span class="hp_myRes_orderInfoBoxIcon">출발일</span>
                              {{item.schedule_start_day}}({{item.schedule_start_day_yoil}})
                            </li>
                            <li class="hp_myRes_orderInfoBoxRed" v-if="item.reservation_pay_status === 1 || item.reservation_pay_status === 2">
                              <span class="hp_myRes_orderInfoBoxIcon">
                                {{ item.reservation_pay_status === 1 ? '주문금액' : '입금요청' }}
                              </span>
                              {{ (item.reservation_pay_status === 1 ? item.reservation_payment_amount : item.reservation_expected_payment_amount).toLocaleString() }}<em>원</em>
                            </li>
                          </ul>
                        </a>
                      </div>
                      <div class="hp_myRes_orderInfoBtnBox">
                        <div class="hp_MobBlockPcNone"><!-- 모바일에서만 보임 -->
                          <!-- <button
                            class="hp_myRes_CancleBtn"
                            v-if="
                              canCancelReservation(item.schedule_start_day_minus) &&
                              item.reservation_pay_status !== 3 &&
                              item.reservation_cancellation_request_status === 0 &&
                              statusData.isWithinWorkingHours"
                            @click="reservationCancellationRequest(item.reservation_ID)"
                          >
                            예약취소요청
                          </button> -->
                          <button
                            v-if="!statusData.isWithinWorkingHours"
                          >
                            <br/>평일 09:30 ~ 18:00 및<br/>공휴일은 예약취소요청이<br/>불가능합니다
                          </button>
                          <button
                            class="hp_myRes_CancleBtn"
                            v-else-if="item.reservation_cancellation_request_status !== 1"
                          >
                            예약취소불가
                          </button>

                        </div>
                        <ul class="hp_MobNonePcBlock"> <!-- pc에서 보이는 부분 -->
                          <li>
                            <p class="hp_myRes_orderPay">{{item.reservation_pay_status_name}}</p> <!-- 결제여부 표시 -->
                          </li>
                          <li>
                            <!-- <button
                              class="hp_myRes_CancleBtn"
                              v-if="
                                canCancelReservation(item.schedule_start_day_minus) &&
                                item.reservation_pay_status !== 3 &&
                                item.reservation_cancellation_request_status === 0 &&
                                statusData.isWithinWorkingHours"
                              @click="reservationCancellationRequest(item.reservation_ID)"
                            >
                              예약취소요청
                            </button> -->
                            <button
                              v-if="!statusData.isWithinWorkingHours"
                            >
                              <br/>평일 09:30 ~ 18시:00 및<br/>공휴일은 예약취소요청이<br/>불가능합니다
                            </button>
                            <button
                              class="hp_myRes_CancleBtn"
                              v-else-if="item.reservation_cancellation_request_status !== 1"
                              >
                              예약취소불가
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="hp_mypageListWrap"  v-if="statusData.myID === 2 && statusData.reservationData.length === 0">
          <div class="hp_mypageListWrapTit">
            예약결제현황
          </div>
          <div class="hp_myResNodataWrap">
            <p class="hp_myResNodataImg">
              <img src="../../../assets/images/icon/icon_reserve.png" alt="예약아이콘" />
            </p>
            <p class="hp_myResNodataTit">예약하신 여행이 없습니다.</p>
          </div>
        </div>
        <!-- 예약결제현황 -->

        <!-- 나의관심여행 -->
        <div class="hp_mypageListWrap"  v-if="statusData.myID === 3 && statusData.interestTravelData.length !== 0">
          <div class="hp_mypageListWrapTit">
            나의관심여행
          </div>
          <div
            class="hp_myResWrap"
            v-for="item in statusData.interestTravelData"
            :key="item.interest_travel_ID">
            <table border="0" cellspacing="0" cellpadding="0" class="hp_myResBox" summary="예약현황">
              <caption>관심여행</caption>
              <colgroup>
                <col width="*">
              </colgroup>
              <tbody>
                <tr>
                  <td>
                    <div class="hp_myRes_orderInfoWrap">
                      <div class="hp_myRes_orderInfoImg hp_MobNonePcBlock"><!-- 이미지 -->
                        <a :href="'/TravelProductDetail?travelProductID=' + item.travel_product_ID">
                          <img :src="item.travel_product_img1" alt="여행 메인 이미지" >
                        </a>
                      </div>
                      <div class="hp_myRes_orderInfoBox"> <!-- 내용 -->
                        <a :href="'/TravelProductDetail?travelProductID=' + item.travel_product_ID">
                          <div class="hp_myRes_orderInfoBoxTit">
                              {{ item.travel_product_name }}
                            </div>
                          <ul>
                            <li class="hp_myRes_orderInfoBoxBlue">
                              <span class="hp_myRes_orderInfoBoxIcon">여행기간</span>
                              <span v-if="item.travel_product_night === 0">당일</span>
                              <span v-else>{{ item.travel_product_night }}박 {{ item.travel_product_day }}일</span>
                            </li>
                            <li class="hp_myRes_orderInfoBoxRed">
                              <span class="hp_myRes_orderInfoBoxIcon">상품가</span>
                              <em>대인 :</em> {{item.schedule_price_min.toLocaleString()}}<em>원, 소인 : </em>{{item.schedule_price_child_min.toLocaleString()}}<em>원</em>
                            </li>
                          </ul>
                        </a>
                      </div>
                      <div class="hp_myRes_orderInfoBtnBox">
                        <div class="hp_MobBlockPcNone"><!-- 모바일에서만 보임 -->
                          <button class="hp_myRes_ViewBtn" @click="goToTravelProductDetail(item.travel_product_ID)">예약하기</button>
                          <button class="hp_myRes_CancleBtn" @click="deleteInterestTravel(item.interest_travel_ID)">삭제하기</button>
                        </div>
                        <ul class="hp_MobNonePcBlock"> <!-- pc에서 보이는 부분 -->
                          <li>
                            <button class="hp_myRes_ViewBtn" @click="goToTravelProductDetail(item.travel_product_ID)">예약하기</button>
                          </li>
                          <li>
                            <button class="hp_myRes_CancleBtn" @click="deleteInterestTravel(item.interest_travel_ID)">삭제하기</button>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="hp_mypageListWrap"  v-if="statusData.myID === 3 && statusData.interestTravelData.length === 0">
          <div class="hp_mypageListWrapTit">
            나의관심여행
          </div>
          <div class="hp_myResNodataWrap">
            <p class="hp_myResNodataImg">
              <img src="../../../assets/images/icon/icon_interest.png" alt="관심여행아이콘" />
            </p>
            <p class="hp_myResNodataTit">등록하신 관심여행이 없습니다.</p>
          </div>
        </div>
        <!-- 나의관심여행 -->

        <!-- 포인트현황 -->
        <div class="hp_mypageListWrap"  v-if="statusData.myID === 4 && statusData.pointLogData.length !== 0">
          <div class="hp_mypageListWrapTit">
            포인트 현황
          </div>
          <div class="hp_mypagePoint_info">
            고객님의 사용 가능한 포인트는 <br/>
            <span class="hp_mypagePoint_infoRed">{{statusData.totalPoint.toLocaleString()}}Point</span> 입니다.
          </div>

          <div class="hp_mypagePoint_subTit">
            포인트적립 및 사용내역
          </div>
          <div class="hp_myResWrap">
            <!-- 모바일용 -->
            <div
              class="hp_mypagePointBoxMo hp_MobBlockPcNone"
              v-for="item in statusData.pointLogData"
              :key="item.point_log_ID"
            >
              <div class="hp_mypagePointBoxMo_left">
                {{item.point_log_registe}}
                <p>{{item.point_log_content}}</p>
              </div>
              <div class="hp_mypagePointBoxMo_right">
                {{item.point_log_point.toLocaleString()}} {{item.point_log_status_name}}
              </div>
            </div>

            <!-- pc용 -->
            <div class="hp_mypagePointBoxPC hp_MobNonePcBlock">
              <table border="0" cellspacing="0" cellpadding="0" class="hp_myResBox" summary="포인트현황">
                <caption>포인트적립 및 사용내역</caption>
                <colgroup>
                  <col width="20%">
                  <col width="*">
                  <col width="15%">
                  <col width="25%">
                </colgroup>
                <thead>
                  <tr>
                    <th scope="col">날짜</th>
                    <th scope="col">내용</th>
                    <th scope="col">구분</th>
                    <th scope="col">포인트</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="item in statusData.pointLogData"
                    :key="item.point_log_ID"
                  >
                    <td>{{item.point_log_registe}}</td>
                    <td>{{item.point_log_content}}</td>
                    <td>{{item.point_log_status_name}}</td>
                    <td>
                      <img class="hp_mypagePointBoxPC_img" src="../../../assets/images/icon/icon_pointBlue.png" alt="포인트표시"/>
                      <span class="hp_mypagePointBoxPC_txt">{{item.point_log_point.toLocaleString()}}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="hp_mypageListWrap"  v-if="statusData.myID === 4 && statusData.pointLogData.length === 0">
          <div class="hp_mypageListWrapTit">
            포인트적립 및 사용내역
          </div>
          <div class="hp_myResNodataWrap">
            <p class="hp_myResNodataImg">
              <img src="../../../assets/images/icon/icon_pointGrey.png" alt="예약아이콘" />
            </p>
            <p class="hp_myResNodataTit">적립내역이 없습니다.</p>
          </div>
        </div>
        <!-- 포인트현황 -->

        <!-- 회원탈퇴 -->
        <div class="hp_mypageListWrap" v-if="statusData.myID === 5">
          <div class="hp_mypageListWrapTit">
            회원탈퇴
          </div>
          <div class="hp_reservationBox">
            <table class="hp_tableForm" cellpadding="0" cellspacing="0" summary="회원탈퇴">
              <caption>회원탈퇴</caption>
              <colgroup>
                <col width="30%">
                <col width="70%">
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">
                    <label for = 'customer_division_name'>가입구분</label>
                  </th>
                  <td>
                    <span class="boldTxt">{{statusData.customerDivisionName}}</span>
                  </td>
                </tr>
                <tr v-if="statusData.customerDivision === 1">
                  <th scope="row">
                    <label for = 'customer_login_ID'>아이디</label>
                  </th>
                  <td>
                    <span class="boldTxt">{{formData.customerLoginID}}</span>
                  </td>
                </tr>
                <tr v-if="statusData.customerDivision === 1">
                  <th>
                    <label for = 'customer_password_secession'>비밀번호</label>
                  </th>
                  <td>
                    <input
                      type = "password"
                      class="hp_tableInputBox"
                      id = 'customer_password_secession'
                      v-model="formData.customerPasswordSecession"
                      maxlength="20"
                    >
                  </td>
                </tr>
                <tr>
                  <th scope="row">탈퇴사유</th>
                  <td>
                    <textarea
                      id = 'customer_secession_reason'
                      v-model="formData.customerSecessionReason"
                      :maxlength="500"
                      placeholder="탈퇴 사유를 입력해주세요 (최대 500자)"
                      rows="6"
                      class="hp_reservTextarea"
                      style="width:98% !important;">
                    </textarea>
                    <p class="hp_reservTextareaNum">{{ formData.customerSecessionReason.length }}/500</p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="hp_myFix_btnReservMob">
            <button @click="updateCustomerSecession">탈퇴하기</button>
          </div>
          <div class="hp_reservation_btnReservPc">
            <button class="hp_reservation_btnReservPc_on" @click="updateCustomerSecession">탈퇴하기</button>
            <button @click="goToHome">취소하기</button>
          </div>
        </div>
        <!-- 회원탈퇴 -->
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import { ref } from 'vue'
import Header from '../Section/Header.vue'
import Footer from '../Section/Footer.vue'
import Scroll from '../Section/Scroll.vue'
import {
  get_session_customer,
  get_hot_keyword_top10,
  get_reservation_name_phone,
  get_reservation_customer_ID,
  get_interest_travel_customer_ID,
  delete_interest_travel,
  get_customer_one,
  update_customer_management,
  check_secession,
  update_customer_secession,
  get_point_log,
  update_reservation_cancellation_request
} from '../../ETC/Axios.vue'
import {
  isWithinWorkingHours
} from '../../ETC/Validation.vue'

export default {
  name: 'My',
  components: {
    Header,
    Footer,
    Scroll
  },
  setup () {
    return {
      sessionData: ref({
        customer: ''
      }),
      statusData: ref({
        myID: 1,
        hotKeywordData: [],
        reservationData: [],
        interestTravelData: [],
        securityCode: '',
        pointLogData: [],
        totalPoint: 0,
        customerDivision: 1,
        customerDivisionName: '자체가입',
        isWithinWorkingHours: false
      }),
      formData: ref({
        customerLoginID: '',
        customerPassword: '',
        customerPasswordCheck: '',
        customerName: '',
        customerPhoneNumber: '',
        customerEmail: '',
        customerMarketingStatus: false,
        securityCode: '',
        customerPasswordSecession: '',
        customerSecessionReason: ''
      })
    }
  },
  methods: {
    formatPhoneNumber (event) {
      let input = event.target.value.replace(/\D/g, '').substring(0, 11)
      let formatted = ''
      if (input.startsWith('010')) {
        if (input.length <= 3) {
          formatted = input
        } else if (input.length <= 7) {
          formatted = input.replace(/(\d{3})(\d{1,4})/, '$1-$2')
        } else {
          formatted = input.replace(/(\d{3})(\d{4})(\d{1,4})/, '$1-$2-$3')
        }
      } else {
        formatted = input.substring(0, 3)
      }

      this.formData.customerPhoneNumber = formatted
    },
    setMyID (id) {
      if (id !== 2 && this.sessionData.customer === '') {
        window.location.href = '/Login'
      } else if (id === 2) {
        get_reservation_customer_ID(
          this.sessionData.customer.customer_ID
        ).then(result => {
          this.statusData.reservationData = result
        })
      } else if (id === 3) {
        get_interest_travel_customer_ID(
          this.sessionData.customer.customer_ID
        ).then(result => {
          this.statusData.interestTravelData = result
        })
      } else if (id === 1 || id === 5) {
        this.statusData.myID = 1
        get_customer_one(
          this.sessionData.customer.customer_ID
        ).then(result => {
          this.formData.customerLoginID = result[0].customer_login_ID
          this.statusData.customerDivision = result[0].customer_division
          this.statusData.customerDivisionName = result[0].customer_division_name
          this.formData.customerName = result[0].customer_name
          this.formData.customerPhoneNumber = result[0].customer_phone_number
          this.formData.customerEmail = result[0].customer_email
          this.formData.customerMarketingStatus = result[0].customer_marketing_status
          this.generateSecurityCode()
        })
      } else if (id === 4) {
        this.statusData.myID = 4
        get_point_log(
          this.sessionData.customer.customer_ID
        ).then(result => {
          if (result.length !== 0) {
            this.statusData.pointLogData = result
            this.statusData.totalPoint = result.reduce((acc, item) => acc + item.point_log_point, 0)
          }
        })
      }
      this.statusData.myID = id
    },
    goToReservationDetail (reservationID) {
      window.location.href = `/ReservationStatus?reservationID=${reservationID}`
    },
    goToTravelProductDetail (travelProductID) {
      window.location.href = `/TravelProductDetail?travelProductID=${travelProductID}`
    },
    goToHome () {
      window.location.href = `/`
    },
    deleteInterestTravel (interestTravelID) {
      delete_interest_travel(
        interestTravelID
      ).then(result => {
        this.statusData.interestTravelData = this.statusData.interestTravelData.filter(item => item.interest_travel_ID !== interestTravelID)
      })
    },
    generateSecurityCode () {
      const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
      let result = ''
      for (let i = 0; i < 4; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length))
      }
      this.statusData.securityCode = result
    },
    updateCustomer () {
      if (this.formData.customerPassword) {
        const passwordRegex = /^(?=.*[0-9])(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/
        if (!passwordRegex.test(this.formData.customerPassword)) {
          alert('비밀번호는 최소 8자리이며, 숫자와 특수문자를 1회 이상 포함해야 합니다.')
          return
        }
        if (this.formData.customerPassword !== this.formData.customerPasswordCheck) {
          alert('비밀번호와 비밀번호 확인이 일치하지 않습니다.')
          return
        }
      }
      const nameRegex = /^[가-힣a-zA-Z]{2,}$/
      if (!nameRegex.test(this.formData.customerName)) {
        alert('이름은 최소 2자리의 한글 또는 영문만 입력할 수 있습니다.')
        return
      }
      const phoneRegex = /^\d{3}-\d{3,4}-\d{4}$/
      if (!phoneRegex.test(this.formData.customerPhoneNumber)) {
        alert('휴대폰 번호는 010-1234-5678 형식으로 입력해주세요.')
        return
      }
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      if (this.formData.customerEmail && !emailRegex.test(this.formData.customerEmail)) {
        alert('이메일 형식이 올바르지 않습니다.')
        return
      }
      if (!this.formData.customerName || !this.formData.customerPhoneNumber) {
        alert('이름과 휴대폰 번호는 필수 입력 항목입니다.')
        return
      }
      if (this.formData.securityCode !== this.statusData.securityCode) {
        alert('보안 코드가 일치하지 않습니다.')
        return
      }
      update_customer_management(
        this.sessionData.customer.customer_ID,
        this.formData.customerPassword,
        this.formData.customerName,
        this.formData.customerPhoneNumber,
        this.formData.customerEmail,
        this.formData.customerMarketingStatus
      ).then(result => {
        alert('정보가 수정되었습니다.')
      }).catch(() => {
        alert('정보 수정 중 오류가 발생했습니다.')
      })
    },
    updateCustomerSecession () {
      check_secession(
        this.formData.customerLoginID,
        this.formData.customerPasswordSecession
      ).then(result => {
        if (result > 0) {
          update_customer_secession(
            this.sessionData.customer.customer_ID,
            this.formData.customerSecessionReason
          ).then(result => {
            alert('회원탈퇴가 완료되었습니다.')
            window.location.href = '/'
          })
        } else {
          this.statusData.spinnerStatus = false
          alert('비밀번호를 확인해주세요.')
        }
      })
    },
    canCancelReservation (scheduleDate) {
      const today = new Date()
      const travelDate = new Date(scheduleDate)

      const diffInTime = travelDate.getTime() - today.getTime()
      const diffInDays = Math.ceil(diffInTime / (1000 * 60 * 60 * 24))
      return diffInDays >= 2
    },
    reservationCancellationRequest (reservation_ID) {
      update_reservation_cancellation_request(reservation_ID).then(result => {
        const reservation = this.statusData.reservationData.find(
          item => item.reservation_ID === reservation_ID
        )
        if (reservation) {
          reservation.reservation_cancellation_request_status = 1
          reservation.reservation_pay_status_name = '예약취소 처리중'
        }
        alert('예약취소요청이 완료되었습니다.\n담당자 연락을 기다려주세요.')
      }).catch(() => {
        alert('예약 취소 요청 중 오류가 발생했습니다.')
      })
    }
  },
  mounted () {
    isWithinWorkingHours().then(result => {
      this.statusData.isWithinWorkingHours = result
    })
    get_hot_keyword_top10().then(result => {
      this.statusData.hotKeywordData = result
    })
    get_session_customer().then(result_session => {
      this.sessionData.customer = result_session
      if (this.$route.query.myID === '2') {
        this.statusData.myID = 2
        if (result_session === '') {
          get_reservation_name_phone(
            this.$route.query.reservation_customer_name,
            this.$route.query.reservation_customer_phone_number
          ).then(result => {
            this.statusData.reservationData = result
          })
        } else {
          this.sessionData.customer = result_session
          get_reservation_customer_ID(
            result_session.customer_ID
          ).then(result => {
            this.statusData.reservationData = result
          })
        }
      } else if (this.$route.query.myID === '3' && result_session !== '') {
        this.statusData.myID = 3
        get_interest_travel_customer_ID(
          result_session.customer_ID
        ).then(result => {
          this.statusData.interestTravelData = result
        })
      } else if ((this.$route.query.myID === '1' || this.$route.query.myID === '5') && result_session !== '') {
        this.statusData.myID = +this.$route.query.myID
        get_customer_one(
          result_session.customer_ID
        ).then(result => {
          this.formData.customerLoginID = result[0].customer_login_ID
          this.statusData.customerDivision = result[0].customer_division
          this.statusData.customerDivisionName = result[0].customer_division_name
          this.formData.customerName = result[0].customer_name
          this.formData.customerPhoneNumber = result[0].customer_phone_number
          this.formData.customerEmail = result[0].customer_email
          this.formData.customerMarketingStatus = result[0].customer_marketing_status
          this.generateSecurityCode()
        })
      } else if (this.$route.query.myID === '4' && result_session !== '') {
        this.statusData.myID = 4
        get_point_log(
          result_session.customer_ID
        ).then(result => {
          if (result.length !== 0) {
            this.statusData.pointLogData = result
            this.statusData.totalPoint = result.reduce((acc, item) => acc + item.point_log_point, 0)
          }
        })
      } else {
        if (result_session === '') {
          window.location.href = '/Login'
        }
      }
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Homepage/My/My.vue